import { hora } from '../lib/formato.js'

// Estados possiveis do autosave. "conflito" nao e erro de rede: alguem salvou
// por cima, e continuar digitando so aumenta o que sera perdido — por isso a
// tela oferece recarregar em vez de tentar de novo sozinha.
export function IndicadorSalvamento({ estado, atualizadoEm, conflito, aoRecarregar }) {
  if (estado === 'conflito') {
    return (
      <div className="indicador indicador--conflito">
        <strong>Conflito</strong>
        <span>
          {conflito?.atualizadoPor
            ? `${conflito.atualizadoPor} salvou este rascunho depois que você carregou.`
            : 'O rascunho mudou desde que você carregou.'}
        </span>
        <button className="botao botao--pequeno" onClick={aoRecarregar}>
          Recarregar do servidor
        </button>
      </div>
    )
  }

  if (estado === 'salvando') return <div className="indicador indicador--salvando">Salvando…</div>

  if (estado === 'erro') {
    return (
      <div className="indicador indicador--falha">
        Falha ao salvar. Nova tentativa no próximo autosave.
      </div>
    )
  }

  if (estado === 'sujo') return <div className="indicador indicador--sujo">Alterações não salvas</div>

  return (
    <div className="indicador indicador--salvo">
      Salvo{atualizadoEm ? ` às ${hora(atualizadoEm)}` : ''}
    </div>
  )
}
